
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { createCrudHooks, processResult, STALE_TIME } from "../common/queries";
import api from "../http-common";

export const courseApi = {
	...createCrudHooks({
		baseKey: "courses",
		basePath: "/courses",
		getAllParams: { include: [{ association: 'subject' }, { association: 'enrollments', include: ['student'] }] },
		getParams: { include: [{ association: 'courseDetails', include: ['attachments', 'parentDetail'] }, { association: 'subject' }, { association: 'enrollments', include: ['student', 'attachments'] }, { association: 'attachments' }] },
	}),

	useGetGrades() {
		const qc = useQueryClient();
		return useQuery({
			queryKey: ["courses", "grades"],
			queryFn: () => api.get("/courses/grades").then(r => processResult(qc, r)),
			staleTime: STALE_TIME,
		});
	},
};
